export default {"src":"/_next/static/media/Bologna.5337e533.svg","height":250,"width":163,"blurWidth":0,"blurHeight":0};